// extracted by mini-css-extract-plugin
export default {"comments":"OrdersListViewItemValue_comments__JA7eG"};